import { tns } from "@/node_modules/tiny-slider/src/tiny-slider";
import './style.css'

export default class Slider {
    constructor(options) {
        this.options = options;
        this.slider = tns({
            items: 1,
            gutter: 0,
            loop: false,
            autoplay: false,
            navPosition: 'bottom',
            ...this.options,
        })
    }
}
